/**
 * Scrolls an opened product tab into view — but only as far as it takes.
 * A tab that already fits on screen is left alone; one taller than the viewport
 * gets its heading pinned under the header so the panel runs down the page.
 */
(function () {
  var GAP = 12;
  var SETTLE_MS = 400;
  var MAX_PASSES = 3;

  function headerOffset() {
    var header = document.querySelector('.site-header');
    if (!header) return 0;

    // Only a pinned header would cover the heading
    var position = getComputedStyle(header).position;
    if (position !== 'sticky' && position !== 'fixed') return 0;

    return header.getBoundingClientRect().height;
  }

  function targetFor(label, panel) {
    var header = headerOffset();
    var top = label.getBoundingClientRect().top + window.scrollY;
    var bottom = panel.getBoundingClientRect().bottom + window.scrollY;
    var room = window.innerHeight - header - GAP * 2;

    if (bottom - top > room) return top - header - GAP;

    if (top < window.scrollY + header + GAP) return top - header - GAP;
    if (bottom > window.scrollY + window.innerHeight - GAP) return bottom - window.innerHeight + GAP;

    return null;
  }

  /**
   * Images loading further down the page move the target while the animation runs,
   * so the position is checked again once things settle and nudged if it drifted.
   */
  function reveal(label, panel, pass) {
    var target = targetFor(label, panel);
    if (target === null) return;

    target = Math.max(target, 0);
    if (Math.abs(target - window.scrollY) < 2) return;

    window.scrollTo({ top: target, left: 0, behavior: 'smooth' });

    if (pass >= MAX_PASSES) return;
    setTimeout(function () {
      reveal(label, panel, pass + 1);
    }, SETTLE_MS);
  }

  document.addEventListener('click', function (event) {
    var label = event.target.closest ? event.target.closest('.tab-label') : null;
    if (!label) return;

    var panel = label.nextElementSibling;
    if (!panel || panel.className.indexOf('tab-panel') === -1) return;

    // Two frames: the panel swaps on :checked, so measure once the layout settled
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        reveal(label, panel, 1);
      });
    });
  }, true);
})();
